<template>
    <div class="page_tool">
        <div class="switch_warp" :class="{active: isOpen}" @click="changePage()">
            <div class="switch_bar bar_left">全景地图</div>
            <div class="switch_bar bar_right">数字画像</div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            open: Boolean
        },
        data(){
            return {
                isOpen: false
            }
        },
        created(){
            this.isOpen = this.open
        },
        methods: {
            changePage(){
                this.isOpen = !this.isOpen
                this.$nextTick(() => {
                    this.$emit('change', this.isOpen)
                })
            }
        }
    }
</script>

<style lang="less">
.page_tool {
    width: 100%;
    position: fixed;
    top: 55px;
    left: 0;

    .switch_warp {
        width: 200px;
        height: 30px;
        line-height: 30px;
        text-align: right;
        background: #e5e5e5;
        border-radius: 30px;
        position: absolute;
        left: 60%;
        transform: translateX(-50%);
        cursor: pointer;

        .switch_bar {
            width: calc(50% - 20px);
            margin: 0 10px 0 12px;
            height: 100%;
            position: absolute;
            top: 0;
            z-index: 1;
            transition: all .3s;

            &.bar_left {
                color: #4FA1A4;
                left: 0;
                background: url('../../../assets/map/bar_left_act.png') left center / 18px no-repeat;
            }

            &.bar_right {
                color: #999;
                right: 0;
                background: url('../../../assets/map/bar_right_def.png') left center / 16px no-repeat;
            }
        }

        &::after {
            content: '';
            width: 50%;
            height: calc(100% - 4px);
            background: #fff;
            border-radius: 30px;
            position: absolute;
            top: 2px;
            left: 2px;
            transition: all .3s;
        }

        &.active {
            .switch_bar {
                &.bar_left {
                    color: #999;
                    background: url('../../../assets/map/bar_left_def.png') left center / 18px no-repeat;
                }

                &.bar_right {
                    color: #4FA1A4;
                    background: url('../../../assets/map/bar_right_act.png') left center / 16px no-repeat;
                }
            }

            &::after {
                left: calc(50% - 2px);
            }
        }
    }
}</style>
